// src/data/defaultServices.js

export const defaultServices = [
  // Cam Filmleri
  { hizmetAdi: 'Solar Gard Nano-Ceramic Serisi', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard High Performance Serisi', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard LX Serisi', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard Non-Reflective Serisi', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard HP Supreme', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard HP Charcoal', aciklama: 'Araç Cam Filmi', fiyat: 0 },
  { hizmetAdi: 'Solar Gard Quantum', aciklama: 'Araç Cam Filmi', fiyat: 0 },

  // Boya Koruma Filmleri (PPF)
  { hizmetAdi: 'Clearshield Pro', aciklama: 'PPF Kaplama', fiyat: 0 },
  { hizmetAdi: 'Clearshield Pro HYDRO', aciklama: 'PPF Kaplama (Hidrofobik)', fiyat: 0 },
  { hizmetAdi: 'Clearshield Pro MATTE', aciklama: 'PPF Kaplama (Mat)', fiyat: 0 },
  { hizmetAdi: 'Clearshield Pro ACTIV', aciklama: 'PPF Kaplama', fiyat: 0 }
];